import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { MaterialModule } from '@app/material.module';
import {
  CardComponent,
  CardContentComponent,
  CardHeaderComponent,
} from './card.component';

@NgModule({
  imports: [CommonModule, TranslateModule, MaterialModule],
  declarations: [CardComponent, CardHeaderComponent, CardContentComponent],
  exports: [CardComponent, CardHeaderComponent, CardContentComponent],
})
export class CardModule {}
